var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-table__item",class:{ 'removing-item': _vm.itemRemoving }},[_c('div',{staticClass:"d-flex d-flex text-break justify-content-between animation-list-item",class:{
      'flex-column block': _vm.screenWidth < 768
    }},[_vm._t("default")],2),_vm._t("additional")],2)}
var staticRenderFns = []

export { render, staticRenderFns }